<template>
  <div>
    <div style=" padding-top: 20px;"><!--- rgb(247, 248, 249) ---><!-- background-color: #fff; -->

      <el-row :span="24" type="flex" style="" align="middle">

        <el-col :sm="18" :md="screenWidth>=1100?8:18">

          <div class="search_div" style="width: 100%;">
            <div class="search_button">
              
              <!-- <span class="search_hot neon-text">
                <router-link to="PageSearchTop"> <i class="el-icon-s-data"></i> 핫클릭 </router-link>  热搜索
              </span> -->

              <router-link v-if="this.keys" :to="'PageSearch?keys='+this.keys"><i class="el-icon-search" style="margin-left: 20px;cursor: pointer;"></i></router-link>
            </div>
            <input maxlength="20" placeholder="띄어쓰기 정확히 입력해주세요" v-model="keys" class="search_input" type="text" @keyup.enter="keys!==''?goTo(''):null">
            <div @mousedown="search_List_mouseDown" @mouseup="search_List_mouseUp" @mouseout="search_List_mouseUp" id="search_List" class="search_List">
              
              <div>오늘의 핫클릭</div><!-- 最近热搜索 -->
              
              <span @mousedown="keys=item;goTo('');" v-for="(item,index) in topkeys" :key="index">
                <el-tag type="success"><i class="el-icon-magic-stick" style="cursor: pointer;"></i> {{item}}</el-tag>
              </span>


            </div>
            
          </div>

        </el-col>
        
        <el-col v-if="screenWidth>=1100" :md="12" align="middle">  

          <!-- <el-row type="flex" justify="end">
            <el-col class="neon-text" :span="6" v-for="(item,index) in link" :key="index"><a :href="item.url" target="_blank">{{ item.title }}</a></el-col>
          </el-row> -->
         
          <el-row type="flex" justify="end">
            <el-col style="color: #fff;" :span="6" ><a class="neon-text" href="https://t.me/toon825" target="_blank">배너문의</a> & <a class="neon-text" href="https://t.me/toon825" target="_blank">대피소</a></el-col>
          </el-row>

        </el-col>

        <el-col :sm="6" :md="screenWidth>=1100?6:16" style="text-align: right;padding-right: 20px;">
          <el-popover
            placement="right"
            width="300"
            v-model="history_show"
            trigger="click">
            <el-table :data="gridData">
              <el-table-column property="title" label="시청기록">
                <template slot-scope="scope">
                  <div @click="HistoryTo('/PagePlayer?ids='+scope.row.query.ids)" style="cursor: pointer;">{{scope.row.title}}</div>
                </template>
              </el-table-column>
            </el-table>
            <span slot="reference" style="color: #FFF;"><i class="el-icon-time" style="padding-right: 5px;"></i>시청기록</span>
          </el-popover>

        </el-col>

      </el-row>

      <el-col :span="24" style=""><!--- rgb(247, 248, 249) ---> <!-- background-color: #fff; -->
        <el-divider></el-divider>
      </el-col>

    </div>
  </div>
</template>

<script>
export default {
  name: 'TopSearch',
  props: {
    // keys_:String,
    screenWidth: Number,
    gridData: Array,
    topkeys: Array,
    link:Array
  },
  data() {
    return {
      // keys:this.keys_
      keys:'',
      history_show:false
    }
  },
  methods: {
    goTo(path) {
      path = '/PageSearch?keys='+ encodeURIComponent(this.keys) + '&type0=0&type1=0&type2=0&type3=0&type4=0&limit=30&page=1'

      // console.log(path , this.$router.currentRoute.fullPath)
      if (path !== this.$router.currentRoute.fullPath) {
        this.loading = true
        // this.$router.push(path);
        this.$router.replace({
          path:'/PageSearch',
          query:{keys:this.keys,
            type0:0,type1:0,type2:0,type3:0,type4:0,limit:30,page:1}
        })
      }

    },
    HistoryTo(path) {
      this.history_show = false

      // console.log(path , this.$router.currentRoute.fullPath)
      if (path !== this.$router.currentRoute.fullPath) {
        this.loading = true
        this.$router.push(path);
      }

    },
    search_List_mouseDown(){
      document.getElementById('search_List').style.visibility='visible'
    },
    search_List_mouseUp(){
      document.getElementById('search_List').style=""
      document.getElementById('search_List').className='search_List'
    },
  }
}
</script>


<style>
  .search_div{
    position: relative;
    .search_button{
      position: absolute;
      z-index: 1000;
      top:3px;
      right: -10px;
      color: #000;
      padding: 7px ;
    }
    .search_hot{
      color: #000;
      cursor: pointer;
    }
    .search_hot:hover{
      color: #F56C6C;
      filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.7)); 
    }
    .search_input{
      position: relative;
      /* background-color: #ccc; */
      line-height: 30px;
      width: 100%;
      margin: 0 10px;
      padding: 3px 10px;
      border-radius: 30px;
      /* filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.7));  */
      
    }
    .search_input:focus {
      outline: none; 
      background-color: #FFF;
      
    }
    
    .search_List {
      color: #999;
      z-index: 1000;
      visibility:hidden;
      /* visibility:visible; */
      position: absolute;
      width: 100%;
      /* height: 200px; */
      margin: 0 15px;
      padding: 10px;
      border-radius: 0 0 10px 10px;
      background-color: #FFF;
      .el-tag {
        margin: 8px;
        color: #F56C6C;
        /* font-weight:bold; */
        border-radius: 10px;
        background-color: #eff;
      }
      .el-tag:hover {
        color: #ff0000;
        font-weight:bold;
        background-color: #efffe0;
      }
    }

    .search_input:focus + .search_List {
      visibility:visible;
    }
  }

  .el-divider {
    background-color: #333;
    position: relative;
  }
</style>
